import React from 'react';
import PropTypes from 'prop-types';
import { Divider as AntDivider } from 'antd';

import { Container, PlanName, PlanType, Info } from './styles';

import { TitlePortlet} from '../../../../styles/components';

import Divider from '../../../../components/Divider';

const AlbumPortlet = (props) => {
	const {
		planName,
		planType,
		planCode,
	} = props;

	const albumLimit = planCode.split("_").pop();

	return (
		<Container>
			<Divider size="small" />

			<AntDivider dashed />

			<Divider size="small" />

			<TitlePortlet>
				<PlanName>{planName}</PlanName>
				{" "}
				<PlanType>({planType})</PlanType>
			</TitlePortlet>

			<Divider size="medium" />

			<Info>
				Quantidade máxima de Álbuns: <b>{
					albumLimit === 'premium' ? 'Ilimitado' : (
						+albumLimit === 1 ? albumLimit + ' Álbum' : albumLimit + ' Álbuns'
					)
				}</b>
			</Info>

			<Divider size="medium" />

			<Info>
				Quantidade máxima de Lâminas: <b>Ilimitado</b>
			</Info>

		</Container>
	)
};

AlbumPortlet.propTypes = {
	planName: PropTypes.string.isRequired,
	planType: PropTypes.string.isRequired,
	planCode: PropTypes.string.isRequired,
}

export default AlbumPortlet;
